module.exports = __webpack_public_path__ + "img/retainer_desk_risk.555afff7.png";